const axios = require("axios").default;

const ClientHttp = function (baseUrl) {
  this.baseUrl = baseUrl;
  this.request = axios.create({
    baseURL: baseUrl,
    responseType: "json",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

ClientHttp.prototype.setAuthHeader = function (zooxToken) { 
  this.request.interceptors.request.use((conf) => {
    if (zooxToken) {
      conf.headers.Authorization = `Bearer ${zooxToken}`;
    }
    return conf;
  });
}

ClientHttp.prototype.getUrlBase = function () {
  return this.baseUrl;
}

ClientHttp.prototype.changeBaseUrl = async function (baseUrlToChange) {
  this.request.interceptors.request.use(
    async (config) => {
      config.baseURL = baseUrlToChange;
      return config;
    }
  );
}

module.exports = { ClientHttp }
